module.exports = __webpack_public_path__ + "img/troy-1kpx.08d95802.png";